(function(angular) {
    'use strict';

    angular.module('aprima-legacy-common').factory('TileGroup', [
        '_',
        'AprimaCache',
        TileGroupFactory,
    ]);


    function TileGroupFactory(
        _,
        AprimaCache
    ) {

        var groupStates = {
            userPreference: 0,
            allExpanded: 1,
            allCollapsed: 2
        };

        return TileGroup;

        function TileGroup(tileGroupName, config, storageType, disablePersistence) {
            var self = this;

            self.setupTile = setupTile;
            self.toggle = toggle;
            self.nextState = nextState;
            self.changeConfiguration = changeConfiguration;
            self.getName = getName;
            self.setPersistence = setPersistence;

            var name = tileGroupName;
            var persist = !disablePersistence;
            var configuration = config || 'default';
            var type = 'tileGroup';
            var tiles = {};
            var groupState = groupStates.userPreference;
            var cache = AprimaCache.getOrCreateOverride(cacheName(), {storagePrefix: 'caches.'});
            if(persist) {
                cache.setStorageMode(storageType || 'localStorage');
            }

            updateTiles();

            function setPersistence(enable) {
                persist = !!enable;
            }

            function getName() {
                return name;
            }

            function cacheName() {
                return type + '.' + name;
            }

            function save() {
                return cache.put(configuration, tiles);
            }

            function get() {
                return cache.get(configuration);
            }

            function toggle(tileId) {
                var tile = tiles[tileId];
                if(!tile) {
                    return;
                }

                tile.isCollapsed = !tile.isCollapsed;
                if(groupState === groupStates.userPreference && persist) {
                    save();
                }
            }

            function setupTile(tileId, defaultValue, forceDefault) {
                var tile = tiles[tileId];

                if(!tile || forceDefault) {
                    tile = tiles[tileId] = {
                        isCollapsed: defaultValue
                    };
                }

                if(groupState === groupStates.allExpanded) {
                    tile.isCollapsed = false;
                }
                else if(groupState === groupStates.allCollapsed) {
                    tile.isCollapsed = true;
                }
                else if(groupState === groupStates.userPreference && persist) {
                    save();
                }

                return tile;
            }

            function updateTiles() {
                if(groupState === groupStates.userPreference) {
                    _.merge(tiles, get());
                    return;
                }

                var newValue = groupState === groupStates.allCollapsed;
                _.forEach(tiles, function (val) {
                    val.isCollapsed = newValue;
                });
            }

            function changeConfiguration(config) {
                if(!config || configuration === config) {
                    return;
                }

                configuration = config;
                updateTiles();
            }

            function nextState() {
                groupState = groupState !== groupStates.allCollapsed ?
                groupState + 1 :
                    groupStates.userPreference;
                updateTiles();
            }
        }
    }

})(window.angular);
